const SET_SEARCH_QUERY = "SET_SEARCH_QUERY";
const SET_SELECTED_ACCOUNT = "SET_SELECTED_ACCOUNT";
const CLEAR_UI = "CLEAR_UI";

export const setSearchQuery = (query) => ({
  type: SET_SEARCH_QUERY,
  payload: query
});

export const setSelectedAccount = (accountId) => ({
  type: SET_SELECTED_ACCOUNT,
  payload: accountId
});

export const clearUI = () => ({
  type: CLEAR_UI
});

const initialState = {
  searchQuery: "",
  selectedAccountId: null
};

export default function uiReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SEARCH_QUERY:
      return { ...state, searchQuery: action.payload };
    case SET_SELECTED_ACCOUNT:
      return { ...state, selectedAccountId: action.payload };
    case CLEAR_UI:
      return initialState;
    default:
      return state;
  }
}
